/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { BookingListElementBookingFragmentDoc } from './BookingListElement.generated';
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type BookingListBookingConnectionFragment = { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason: Types.BookingCancelReason | null, summary: string | null, assignedStaff: { displayName: string } } }> };

export const BookingListBookingConnectionFragmentDoc = gql`
    fragment BookingListBookingConnection on BookingConnection {
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    node {
      ...BookingListElementBooking
    }
  }
}
    ${BookingListElementBookingFragmentDoc}`;